import React from 'react'
import PropTypes from 'prop-types'

const ColorSpot = ({ color, size, ...otherProps }) => (
    <div
        className="img-thumbnail"
        style={ { width: size, height: size } }
        { ...otherProps }
    >
        <span style={ { display: 'block', width: '100%', height: '100%', backgroundColor: color } } />
    </div>
)


ColorSpot.propTypes = {
    color : PropTypes.string,
    size  : PropTypes.number
}

ColorSpot.defaultProps = {
    size: 30
}

export default ColorSpot
